/**
 * Confluence editor comment watch plugin.
 *
 * It will add the "watch" checkbox to the editor save bar if the global variable
 * AJS.Meta.getOverride('use-watch') is set
 */

import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import { getOverride } from '@confluence/meta';

const template = (translate, userWatchingOwnContent) => `
    <ul class="toolbar-group toolbar-group-watch-page" id="toolbar-group-watch-page-after-comment">
        <li class="toolbar-item">
            <input id="watchPage" name="watchPageAfterComment" value="true" type="checkbox" ${
							userWatchingOwnContent ? 'checked="checked"' : ''
						}/>
            <label for="watchPage">${translate('comment.notification.enable')}</label>
        </li>
    </ul>
`;

const plugin = {
	init: (ed) => {
		ed.on('init', () => {
			if (getOverride('use-watch')) {
				// we can only guarantee that this variable will be populated when the editor is initialised
				const params = {
					userWatchingOwnContent: getOverride('user-watching-own-content'),
				};
				$('#rte-savebar-tinymce-plugin-point').append(
					template((s) => ed.translate(s), params.userWatchingOwnContent),
				);
			}
		});
	},

	getInfo: () => {
		return {
			longname: 'Confluence Watch',
			author: 'Atlassian',
			authorurl: 'http://www.atlassian.com',
			version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
		};
	},
};

export default () => {
	window.tinymce.create('tinymce.plugins.ConfluenceWatch', plugin);
	window.tinymce.PluginManager.add('confluencewatch', window.tinymce.plugins.ConfluenceWatch);
};
